/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockPlay = createReactComponent("outline", "clock-play", "IconClockPlay", [["path", { "d": "M12 7v5l2 2", "key": "svg-0" }], ["path", { "d": "M17 22l5 -3l-5 -3z", "key": "svg-1" }], ["path", { "d": "M13.017 20.943a9 9 0 1 1 7.831 -7.292", "key": "svg-2" }]]);

export { IconClockPlay as default };
//# sourceMappingURL=IconClockPlay.mjs.map
